import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Crema',
    description:
        'Order ahead, skip the line, and earn a free drink every twelve with the Crema coffee app.',
    url: 'https://crema.app'
}